import { CasDisplayField, CasStackRow } from 'src/compass/shared/components';
import formatCurrency from 'src/compass/shared/util/formatCurrency';

export default function CommissisonsTotalView(total: number, label: string = 'Total') {
  return (
    <CasStackRow flexGrow={1} justifyContent="flex-start">
      {total !== undefined && <CasDisplayField label={label} value={formatCurrency(total)} />}
    </CasStackRow>
  );
}
